import { Link } from 'react-router-dom';
import { Box, Breadcrumbs, SxProps, Theme, Typography } from '@mui/material';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';

const linkStyles: SxProps<Theme> = { '& a': { textDecoration: 'none' } };

interface LinkConfig {
  to: string;
  text: string;
}
interface NavigatorProps {
  links?: LinkConfig[];
  last: string;
}

export const Navigator = ({ links, last }: NavigatorProps) => {
  return (
    <Breadcrumbs aria-label='breadcrumb' separator={<NavigateNextIcon fontSize='small' />}>
      {links &&
        links.map(l => (
          <Box key={l.to} sx={linkStyles}>
            <Link to={l.to}>
              <Typography color='textPrimary'>{l.text}</Typography>
            </Link>
          </Box>
        ))}
      <Typography color='inherit'>{last}</Typography>
    </Breadcrumbs>
  );
};
